/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Mapping_InvalidInputs */

const en_sch_err_mapping_invalid = /** @type {(inputs: Sch_Err_Mapping_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One of the chosen statuses does not belong to the new workflow. Reload and try again.`)
};

const de_sch_err_mapping_invalid = /** @type {(inputs: Sch_Err_Mapping_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einer der gewählten Status gehört nicht zum neuen Workflow. Lade neu und versuche es erneut.`)
};

/**
* | output |
* | --- |
* | "One of the chosen statuses does not belong to the new workflow. Reload and try again." |
*
* @param {Sch_Err_Mapping_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_mapping_invalid = /** @type {((inputs?: Sch_Err_Mapping_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Mapping_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_mapping_invalid(inputs)
	return en_sch_err_mapping_invalid(inputs)
});